<template>
  <Layout :removePadding="true" :onlyLogoHeader="true">
    <div
      class="text-center primary--text display font-weight-bold"
      :class="$vuetify.breakpoint.smAndDown ? 'pt-3 pb-0' : 'pt-10 pb-5'"
    >
      {{ $t("sign_in.login") }}
    </div>
    <div
      class="mx-10"
      :class="$vuetify.breakpoint.smAndDown ? 'mt-9' : 'mt-13'"
    >
      <v-col class="primary--text py-5" v-for="(field, i) in fields" :key="i">
        <v-row>
          {{ $t("sign_in." + i) }}
        </v-row>
        <v-row align="center" justify="space-around">
          <v-text-field
            flat
            solo
            hide-details
            single-line
            :append-icon="
              i === 'password'
                ? showPassword
                  ? 'visibility_off'
                  : 'visibility'
                : null
            "
            @click:append="showPassword = !showPassword"
            v-model="fields[i]"
            :type="
              i === 'password' ? (showPassword ? 'text' : 'password') : 'text'
            "
            class="input-custom w-100"
          >
          </v-text-field>
          <span v-if="formErrors" class="red--text w-100">{{
            formErrors[i]
          }}</span>
        </v-row>
      </v-col>

      <v-alert
        :value="!!formErrors && !!formErrors.login"
        color="error"
        icon="warning"
        class="subheading py-1 px-2 mb-2"
        outlined
      >
        {{ formErrors ? formErrors.login : "" }}
      </v-alert>

      <div class="d-flex justify-end align-center" style="height: 30px">
        <p
          class="text-center primary--text pt-5 clickable"
          @click="$router.push({ name: routeNames.RECOVER })"
        >
          {{ $t("sign_in.forgot_password") }}
        </p>
      </div>
    </div>

    <div class="mt-13 mx-10">
      <v-btn
        class="px-13 py-7 mb-5 w-100 primary semi-rounded text-over-secondary--text"
        style="color: var(--text-over-secondary) !important"
        x-large
        outlined
        outlined-border-width="7"
        :loading="sentRequest"
        :disabled="!fields.email || !fields.password"
        @click="login()"
      >
        {{ $t("sign_in.login") }}
      </v-btn>
      <v-btn
        color="primary"
        class="px-13 py-7 w-100 semi-rounded"
        x-large
        outlined
        outlined-border-width="7"
        @click="$router.push({ name: routeNames.SELECT_SIGN_UP })"
      >
        {{ $t("sign_in.register") }}
      </v-btn>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/MainLayout";
import { Credentials } from "../entities/request-bodies/Credentials";

export default {
  name: "LoginView",
  props: ["routeNames", "auth"],
  data() {
    return {
      fields: {
        email: null,
        password: null,
      },
      sentRequest: false,
      showPassword: false,
      formErrors: null,
    };
  },
  methods: {
    login() {
      const context = this;
      this.sentRequest = true;
      const credentials = new Credentials(
        this.fields.email,
        this.fields.password
      );
      this.auth.login(context, credentials).finally(() => {
        context.sentRequest = false;
      });
    },
  },
  components: {
    Layout,
  },
};
</script>

<style>
.theme--light.v-btn.v-btn--disabled {
  opacity: 0.5 !important;
}
</style>
